import React from 'react';

const SubmitPostPage = () => {
  return (
    <>
      <h2>Submit a post</h2>
      <form action="">
        <textarea name="" id="" cols="30" rows="10"></textarea>
        <button>Submit</button>
      </form>
    </>
  );
};

export default SubmitPostPage;
